import React from "react";
import { Stack, TextField } from "@mui/material";
import { formatLiteral, parseLiteral } from "./constants";
import type { OperandTypeComponentProps } from "./types";

export interface RightLiteralOnlyProps extends OperandTypeComponentProps {
    /** When true, only allow numeric input (e.g. for gt/gte/lt/lte). */
    numericOnly?: boolean;
}

function parseNumeric(input: string): number | undefined {
    const trimmed = input.trim();
    if (trimmed === "") return undefined;
    const n = Number(trimmed);
    return Number.isFinite(n) ? n : undefined;
}

/** Right side when left operand is derived attribute or key: show only literal value input. */
export const RightLiteralOnly: React.FC<RightLiteralOnlyProps> = ({ value, onChange, numericOnly = false }) => {
    if (numericOnly) {
        const display =
            typeof value?.value === "number" && Number.isFinite(value.value) ? String(value.value) : "";
        return (
            <Stack spacing={1}>
                <TextField
                    size="small"
                    label="Value (number)"
                    type="number"
                    value={display}
                    onChange={(e) => {
                        const parsed = parseNumeric(e.target.value);
                        onChange(parsed !== undefined ? { value: parsed } : { value: "" });
                    }}
                    fullWidth
                />
            </Stack>
        );
    }
    return (
        <Stack spacing={1}>
            <TextField
                size="small"
                label="Value"
                value={formatLiteral(value?.value)}
                onChange={(e) => onChange({ value: parseLiteral(e.target.value) })}
                fullWidth
            />
        </Stack>
    );
};
